export default __webpack_public_path__ + "static/media/icon_youtube.a88852c0.svg";